import React from "react";

interface Trip {
  name: string;
  tripDate?: string;
  tripEndDate?: string;
}

interface TripSummaryCardProps {
  trip: Trip;
}

const TripSummaryCard: React.FC<TripSummaryCardProps> = ({ trip }) => {
  return (
    <section className="card mb-4">
      <div className="card-header"><h5>Trip Details</h5></div>
      <div className="card-body">
        {/* Desktop layout */}
        <div className="d-none d-md-block">
          <p><strong>Description:</strong> {trip.name}</p>
          <p><strong>Trip Date:</strong> {trip.tripDate ? new Date(trip.tripDate).toLocaleDateString() : "Not set"}</p>
          <p><strong>Trip End Date:</strong> {trip.tripEndDate ? new Date(trip.tripEndDate).toLocaleDateString() : "Not set"}</p>
        </div>

        {/* Mobile layout */}
        <div className="d-md-none">
          <div className="card shadow-sm mb-3 p-3">
            <p className="mb-2"><strong>Description:</strong><br />{trip.name}</p>
            <p className="mb-0"><strong>Trip Date:</strong><br />{trip.tripDate ? new Date(trip.tripDate).toLocaleDateString() : "Not set"}</p>
            <p className="mb-0"><strong>Trip End Date:</strong><br />{trip.tripEndDate ? new Date(trip.tripEndDate).toLocaleDateString() : "Not set"}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TripSummaryCard;
export {};
